<div class="container">
  <div class="row justify-content-center mt-5">
    <button class="btn btn-primary">The requestor must be the admin for your channel and instance in Q2E</button>
  </div>
  <div class="justify-content-center mt-5 row">
    <div class="col-sm-10 col-md-8 ">
      <div class="card">
        <div class="card-body">
          <div class="card-title mb-3">
            <h4 class="text-center">Q2E GateCube Installation Request</h4>
          </div>
          <form [formGroup]="rgFrmGrp" (ngSubmit)="onSubmitMemberInfo()">
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" formControlName="name" id="name" class="form-control" placeholder="" required
                [ngClass]="{ 'is-invalid': f.name.touched && f.name.errors, 'is-valid': f.name.valid }">
              <div *ngIf="f.name.touched && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">Name is required!</div>
              </div>
            </div>
            <div class="form-group">
              <label for="name">Email:</label>
              <input type="text" formControlName="emailId" id="emailId" class="form-control" placeholder="" required
                [ngClass]="{ 'is-invalid': f.emailId.touched && f.emailId.errors, 'is-valid': f.emailId.valid }">
              <div *ngIf="f.emailId.touched && f.emailId.errors" class="invalid-feedback">
                <div *ngIf="f.emailId.errors.required">Email is required!</div>
              </div>
            </div>
            <div class="form-group">
              <label for="name">Company Name:</label>
              <input type="text" formControlName="companyName" id="companyName" class="form-control" placeholder=""
                required
                [ngClass]="{ 'is-invalid': f.companyName.touched && f.companyName.errors, 'is-valid': f.companyName.valid }">
              <div *ngIf="f.companyName.touched && f.companyName.errors" class="invalid-feedback">
                <div *ngIf="f.companyName.errors.required">Company Name is required!</div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-12 ">
                  <button type="submit" [disabled]="rgFrmGrp.invalid || isLoading" class="btn btn-primary float-right">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span> Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>

    </div>
  </div>

</div>